/**
 * Зеркало переписки для мокапа инбокса (#1330).
 *
 * ## Почему стор, а не React-контекст
 *
 * Ответ агента приходит ПОТОКОМ: у сообщения меняется текст на каждом куске.
 * Через контекст это перерисовывало бы всё поддерево вместе с самим виджетом
 * на каждый токен. Внешний стор с подпиской перерисовывает только того, кто
 * подписан, — мокап инбокса.
 *
 * ## Канал
 *
 * Канал живёт здесь же и проставляется сообщению ОДИН раз, когда оно впервые
 * попало в зеркало. Читать текущий выбор при отрисовке нельзя: переключение
 * канала задним числом переклеивало бы метку у всей прошлой переписки.
 */

let snapshot = [];
let channel = 'website';
const listeners = new Set();

// Реплики, отправленные КОМАНДОЙ из мокапа панели: их id запоминаются, чтобы
// в зеркале они значились «Sales team», а не ответом ассистента. Посетителю
// виджет показывает их обычным ответом — со стороны сайта это и есть ответ
// дилера, кто бы его ни написал.
let teamSeq = 0;
const teamIds = new Set();
const inboundListeners = new Set();

/** Канал, которым помечаются НОВЫЕ сообщения. */
export function setChannel(next) {
  channel = next;
}

/**
 * Положить в зеркало текущую переписку виджета.
 *
 * @param {Array<{id: string, role: string, text: string}>} messages
 */
export function publish(messages) {
  const known = new Map(snapshot.map((m) => [m.id, m]));

  const next = (messages || [])
    .filter((m) => m && typeof m.text === 'string' && m.text.length > 0)
    .map((m) => {
      const seen = known.get(m.id);
      return {
        id: m.id,
        from: roleOf(m),
        text: m.text,
        // Канал и время — от ПЕРВОГО появления сообщения.
        channel: seen ? seen.channel : channel,
        at: seen ? seen.at : Date.now(),
      };
    });

  // Поток шлёт публикацию на каждый кусок текста; если ничего не изменилось,
  // подписчиков не будим — иначе мокап перерисовывался бы вхолостую.
  if (isSame(snapshot, next)) return;

  snapshot = next;
  listeners.forEach((fn) => fn());
}

/**
 * Кто автор реплики в терминах мокапа инбокса.
 *
 * Имена ролей — те, что понимает мокап (`AUTHOR_LABEL`,
 * `.panel-inbox__bubble--*`): `agent`, а не `assistant`. С чужим именем ответ
 * отрисовывался голым текстом без плашки и без подписи.
 */
function roleOf(m) {
  if (teamIds.has(m.id)) return 'human';
  return m.role === 'user' ? 'customer' : 'agent';
}

/**
 * Ответ команды из мокапа панели: уходит в чат посетителя.
 *
 * Обратная сторона зеркала (#1330). Ради неё в мокапе и стоит тумблер «AI
 * mode»: отжали — и разговор ведёт человек, ровно как в настоящей панели.
 *
 * @param {string} text
 * @returns {boolean} было ли что отправить
 */
export function sendFromTeam(text) {
  const clean = (text || '').trim();
  if (!clean) return false;

  teamSeq += 1;
  const id = `team-${teamSeq}`;
  teamIds.add(id);
  inboundListeners.forEach((fn) => fn({ id, text: clean }));
  return true;
}

/** Подписка виджета на реплики команды. */
export function subscribeInbound(listener) {
  inboundListeners.add(listener);
  return () => inboundListeners.delete(listener);
}

function isSame(a, b) {
  if (a.length !== b.length) return false;
  return a.every((m, i) => m.id === b[i].id && m.text === b[i].text && m.channel === b[i].channel);
}

export function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getSnapshot() {
  return snapshot;
}

/** Для тестов и полной очистки. */
export function reset() {
  snapshot = [];
  channel = 'website';
  teamSeq = 0;
  teamIds.clear();
  listeners.clear();
  inboundListeners.clear();
}

export const chatMirror = {
  setChannel,
  publish,
  subscribe,
  getSnapshot,
  sendFromTeam,
  subscribeInbound,
  reset,
};

export default chatMirror;
